define('home/views/SettingsModerationView',[
    'jquery',
    'underscore',

    'home/templates/settingsModeration',
    'home/views/common/BaseSettingsView',
], function (
    $,
    _,

    settingsModerationTemplate,
    BaseSettingsView
) {
    'use strict';

    var SettingsModerationView = BaseSettingsView.extend({
        template: settingsModerationTemplate,

        templateHelpers: function () {
            return {
                moderatesForums: !_.isEmpty(this.model.get('forum_subscriptions')),
            };
        },

        getFormData: function () {
            var data = BaseSettingsView.prototype.getFormData.apply(this, arguments);

            // explicitly set checkbox fields to true or false so that
            // the model is updated correctly
            data.receive_unapproved = Boolean(data.receive_unapproved);
            data.receive_spam = Boolean(data.receive_spam);

            // This is displayed in the html form as a 'receive_approved' checkbox,
            // and we have to flip it to get the correct value for disable_approved
            data.disable_approved = !data.receive_approved;

            // use $.extend to deep copy so that nested objects are not referenced in the new object
            // and changing the subscribed attribute won't be reflected in the model
            var forumSubscriptions = $.extend(true, {}, this.model.attributes.forum_subscriptions);

            _.each(forumSubscriptions, function (forum, forumId) {
                forum.subscribed = Boolean(data['forum_' + forumId]);

                // remove forum_* from data so it isn't set on the model
                delete data['forum_' + forumId];
            });

            data.forum_subscriptions = forumSubscriptions;

            return data;
        },
    });

    return SettingsModerationView;
});

